export default {
    props: {
        messagesLoading: {
            type: String,
            kComposite: 'messages.loading'
        }, 
        messagesRequestFailed: {
            type: String,
            kComposite: 'messages.requestFailed'
        }, 
        messagesRetry: {
            type: String,
            kComposite: 'messages.retry'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/Messages.js